import { format, isBefore, isEqual, parse, parseISO, subDays, subHours } from 'date-fns';
import { DATE_FORMATS, FILTER_RELATIVE_DATE_RANGE } from './DateRange.constants';
import { DateType } from './DateRange.types';

const NO_DATA = '--';

export const formatDate = (
  date: string | Date | undefined | null,
  dateFormat: string = DATE_FORMATS.MONTH_ABBR_DATE
): string => {
  try {
    if (date == null) {
      return NO_DATA;
    }
    if (typeof date === 'string') {
      const parsedDate = parseISO(date);
      return format(parsedDate, dateFormat);
    }
    return format(date, dateFormat);
  } catch (e) {
    return NO_DATA;
  }
};

export const isBeforeOrEqualIgnoringTime = (date: Date, dateToCompare: Date): boolean => {
  const dateCopy = new Date(date);
  const dateMidnight = dateCopy.setHours(0, 0, 0);
  const dateToCompareCopy = new Date(dateToCompare);
  const dateToCompareMidnight = dateToCompareCopy.setHours(0, 0, 0);
  return isBefore(dateMidnight, dateToCompareMidnight) || isEqual(dateMidnight, dateToCompareMidnight);
};

export const parseDate = (date: string, format: string = DATE_FORMATS.MONTH_ABBR_DATE): Date =>
  parse(date, format, new Date());

export const getDateRange = (range: FILTER_RELATIVE_DATE_RANGE): { startDate: DateType; endDate: DateType } => {
  const today = new Date();
  let startDate: DateType;
  switch (range) {
    case FILTER_RELATIVE_DATE_RANGE.LAST_24HRS:
      startDate = subHours(today, 24);
      break;
    case FILTER_RELATIVE_DATE_RANGE.LAST_7DAYS:
      startDate = subDays(today, 7);
      break;
    case FILTER_RELATIVE_DATE_RANGE.LAST_30DAYS:
      startDate = subDays(today, 30);
      break;
    case FILTER_RELATIVE_DATE_RANGE.LAST_90DAYS:
      startDate = subDays(today, 90);
      break;
    default:
      startDate = null;
      break;
  }
  return { startDate, endDate: today };
};
